export const DEFAULT_COMPANY = 'riide';
export const MIN_PREBOOK_TIME = 0;
export const DEFAULT_COMPANY_COUNTRY_CODE = 'GB';
